'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' });

var ModeEdit = function ModeEdit(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ModeEdit = (0, _pure2.default)(ModeEdit);
ModeEdit.muiName = 'SvgIcon';

exports.default = ModeEdit;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ModeEdit.js
// module id = 2616
// module chunks = 0